import { createSignal, Show } from "solid-js";
import { useSearchParams } from "@solidjs/router";
import c from "class-c";

import ContainerButton from "@repo/ui/buttons/ContainerButton";
import Form from "@repo/ui/inputs/Form";

import ChipContainer from "./ChipContainer";

import styles from "./SearchInput.module.scss";

declare namespace SearchInput {
  type Props = {
    placeholder: string;
    active?: boolean;
    onChange?(state: { active: boolean }): void;
    expand?: boolean;
    class?: string;
  };
}

function SearchInput({
  placeholder,
  active,
  onChange,
  expand = false,
  class: className,
  ...props
}: D<SearchInput.Props>) {
  let inputRef: HTMLInputElement | undefined;

  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = createSignal((searchParams.q as string) || "");

  return (
    <div class={`row-center ${expand && "expand"}`}>
      <div
        class={c`row-center ${(active || expand) && "expand"} ${styles["search-bar"]} ${className}`}
        {...props}
      >
        <span class="icon:small color:moderate-weak"></span>
        <Form
          class="expand"
          onSubmit={() => {
            setSearchParams({ q: value() }, { replace: true });
            if (!value()) {
              onChange?.({ active: false });
              inputRef?.blur();
            }
          }}
        >
          <input
            ref={inputRef}
            type="text"
            name="search"
            autocomplete="off"
            placeholder={placeholder}
            value={value()}
            onInput={(e) => setValue(e.currentTarget.value)}
            onClick={() => onChange?.({ active: true })}
            class={styles["search-input"]}
          />
        </Form>
        {value() && (
          <ContainerButton
            class={styles["clear-btn"]}
            onClick={() => {
              setValue("");
            }}
          >
            
          </ContainerButton>
        )}
      </div>
      <Show when={active}>
        <ChipContainer class="ml-1">
          <ContainerButton
            onClick={() => {
              onChange?.({ active: false });
              setValue("");
              setSearchParams({ q: value() }, { replace: true });
            }}
          >
            Cancel
          </ContainerButton>
        </ChipContainer>
      </Show>
    </div>
  );
}

export default SearchInput;
